import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import { useGetSearchParamsObj } from '@/src/hooks/srp/searchParams'
import { DeviceType } from '@/src/types/deviceType'
import FlightNotFound from './FlightNotFound'

interface EmptyFlightScreenProps {
    deviceType: DeviceType
}

const EmptyFlightScreenWrapper = ({ deviceType }: EmptyFlightScreenProps) => {
    const { urlQueryObj } = useGetSearchParamsObj()
    const fromAirport = urlQueryObj.from || ''
    const toAirport = urlQueryObj.to || ''
    const { appliedFilterList, handleClearAllFilters } = useClearFilters()

    return (
        <FlightNotFound
            deviceType={deviceType}
            fromAirport={fromAirport}
            toAirport={toAirport}
            appliedFilters={appliedFilterList}
            handleClearAllFilters={handleClearAllFilters}
        />
    )
}

export default EmptyFlightScreenWrapper
